import React, { Component } from "react";
import SharedHelmet from ".././Helmet";
import ramadanImg from "../../../images/ramadan.webp";
import eidAdhaImg from "../../../images/eid-adha.webp";
import eidFatrImg from "../../../images/eid-fatr.webp";
import motherImg from "../../../images/mother.webp";
import schoolImg from "../../../images/back-to-school.webp";
import footballImg from "../../../images/football.webp";
import summerImg from "../../../images/summer.webp";
class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "منوعات",
      links: {
        technology: [],
        health: [],
        women: [],
        منوعات: [
          {
            id: 1,
            title: "كم باقي على رمضان 2026",
            url: "/articles-ar/ramadan/",
            imageUrl: ramadanImg,
            description: "اكتشف موعد رمضان 2026 الان",
          },
          {
            id: 2,
            title: "كم باقي على عيد الاضحى 2026",
            url: "/articles-ar/eid-adha/",
            imageUrl: eidAdhaImg,
            description: "اكتشف موعد عيد الاضحى 2026 الان",
          },
          {
            id: 3,
            title: "كم باقي على عيد الفطر 2026",
            url: "/articles-ar/eid-fatr/",
            imageUrl: eidFatrImg,
            description: "اكتشف موعد عيد الفطر 2026 الان",
          },
          {
            id: 4,
            title: "كم باقي على ليلة النصف من شعبان 2026",
            url: "/articles-ar/shaban/",
            imageUrl: eidFatrImg,
            description: "اكتشف موعد ليلة النصف من شعبان 2026 الان",
          },
          {
            id: 5,
            title: "كم باقي على راس السنة الهجرية 2026",
            url: "/articles-ar/hijri/",
            imageUrl: eidFatrImg,
            description: "اكتشف موعد راس السنة الهجرية 2026 الان",
          },
          {
            id: 6,
            title: "كم باقي على عيد الام 2026",
            url: "/articles-ar/motherday/",
            imageUrl: motherImg,
            description: "اكتشف موعد عيد الام 2026 الان",
          },
          {
            id: 7,
            title: "كم باقي على العام الدراسي الجديد في السعوية 2026",
            url: "/articles-ar/schooldaySA/",
            imageUrl: schoolImg,
            description: "اكتشف موعد عيد الام 2026 الان",
          },
          {
            id: 8,
            title: "كم باقي على كأس العالم 2026",
            url: "/articles-ar/worldcup/",
            imageUrl: footballImg,
            description: "اكتشف موعد كأس العالم 2026 الان",
          },
          {
            id: 8,
            title: "كم باقي على الالمبياد 2028",
            url: "/articles-ar/olympics/",
            imageUrl: footballImg,
            description: "اكتشف موعد الالمبياد 2028 الان",
          },
          {
            id: 8,
            title: "كم باقي على كاس اسيا 2027",
            url: "/articles-ar/asian-cup/",
            imageUrl: footballImg,
            description: "اكتشف موعد كاس اسيا 2027 الان",
          },
          {
            id: 9,
            title: "كم باقي على الصيف 2026",
            url: "/articles-ar/summer/",
            imageUrl: summerImg,
            description: " اكتشف موعد الصيف 2026 الان",
          },
        ],
      },
    };
  }
   render() {
    const TITLE = "مقالات صحية ورياضية متنوعة";
    const DESCRIPTION =
      "استكشف عالم التكنولوجيا والصحة والمال وتمكين النساء ونصائح الجمال ورؤى إسلامية. ابق مستفيدًا وصحيًا وماليًا واعياً فيما يتعلق بنمط حياتك وروحيتك";
    const KEYWORDS =
      "استكشف عالم التكنولوجيا والصحة والمال وتمكين النساء ونصائح الجمال ,مقالات اسلامية إسلامية";
    const OG_URL = "https://do-calculate.com/articles-ar/";
    const { activeTab, links } = this.state;
    const activeTabLinks = links[activeTab];
    const tabContainerStyle = {
      display: "flex",
      borderBottom: "1px solid #dee2e6",
    };
    const tabButtonStyle = {
      flex: 1,
      padding: "10px 15px",
      cursor: "pointer",
      border: "none",
      background: "#f8f9fa",
      color: "#495057",
      textAlign: "center",
      fontWeight: "500",
      borderRadius: "0.25rem",
      margin: "0",
      borderBottom: "2px solid transparent",
    };
    const tabButtonActiveStyle = {
      ...tabButtonStyle,
      background: "#ffffff",
      color: "#007bff",
      borderBottom: "2px solid #007bff",
    };
    const tabContentStyle = {
      padding: "15px",
      borderTop: "1px solid #dee2e6",
    };
    const availableTabs = Object.keys(links)
      .filter((tab) => links[tab] && links[tab].some((article) => article.id))
      .map((tabName) => {
        if (tabName === "technology") {
          return "تكنولوجيا";
        }
        return tabName;
      });
    return (
      <div className="rtl">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div className="bg-success text-white" role="alert" style={{height: "50px", alignItems: "center", display: "flex", justifyContent: "center"}}>
          {DESCRIPTION}.
          <div className="text-center">
          </div>
        </div>
        <hr />
        <section id="tabs">
          <div style={tabContainerStyle}>
            {availableTabs.map((tabName) => (
              <button
                key={tabName}
                style={
                  activeTab === tabName ? tabButtonActiveStyle : tabButtonStyle
                }
                onClick={() => this.handleTabClick(tabName)}
              >
                {tabName.charAt(0).toUpperCase() + tabName.slice(1)}
              </button>
            ))}
          </div>
        </section>
        {activeTabLinks && activeTabLinks.length > 0 && (
          <section id="gallery" style={tabContentStyle}>
            <div className="container">
              <div className="row">
                {activeTabLinks.map(
                  (link) =>
                    link.id && (
                      <div
                        key={link.id}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                      >
                        <div className="card">
                          <img
                            src={link.imageUrl}
                            alt={link.title}
                            className="card-img-top"
                            style={{ width: "100%", height: "200px" }}
                          />
                          <div className="card-body">
                            <h5 className="card-title">{link.title}</h5>
                            <p className="card-text">{link.description}</p>
                            <a
                              href={link.url}
                              className="btn btn-outline-success btn-sm"
                            >
                              اقرأ المزيد
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
export default Articles;